export default {
  mounted () {
    if (!!window.MSInputMethodContext && !!document.documentMode) {
        document.body.setAttribute('ie11', '')
    }
  }
}
